// 公共的配置，给vue脚手架和storybook脚手架共用的
import Vue from 'vue';

import '@/assets/styles/reset.scss'; // 重置样式
import '@/assets/styles/elFit.scss';
import '@/r-fusion-pc/r-fusion-pc';
import './directives/index';
import VueClipboard from 'vue-clipboard2';
import CardPopup from '@/components/Pay/cardPopup.js';
import RLoading from '@/components/Loading/index.js';

Vue.use(VueClipboard);
Vue.prototype.$cardPopup = CardPopup;
Vue.prototype.$rLoading = RLoading;

require('@/utils/fingerprint');
